import * as M from 'shared/types/models';

import { isTimelineMetric } from 'shared/helpers';

export function isTimelineColumn(column: M.Column) {
  return column.kind === 'metric' && isTimelineMetric(column.metricID)
}
